<template>
  <el-button :size="size" :type="color" :icon="icon" :disabled="disabled" @click="handleExport"> {{ text }}</el-button>
</template>

<script>
import Excel from 'exceljs';
import filesaver from 'file-saver';
export default {
    props: {
        size: {
            type: String,
            default: 'small'
        },
        color: {
            type: String,
            default: 'primary'
        },
        icon: {
            type: String,
            default: 'mdi mdi-download'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            default: 'Extract'
        },
        filename: {
            type: String,
            default: 'exported-xlsx'
        },
        filesheet: {
            type: String,
            default: 'Sheet1'
        },
        tableColumns: {
            type: Array
        },
        tableData:  {
            type: Array
        }
    },
    methods: {
        async handleExport(){
            if(this.tableColumns < 1){
                this.$message({type: 'error', message: "Please provide/select table columns!"})
                return
            }

            if(this.tableData.length < 1){
                this.$message({type: 'error', message: "Please provide/select table rows!"})
                return
            }
            const workbook = new Excel.Workbook();
            const worksheet = await workbook.addWorksheet(this.filesheet);
            worksheet.columns = this.tableColumns; //@header, @key, @width
            await worksheet.addRows(this.tableData); //array of data based on columns
            
            const buffer = await workbook.xlsx.writeBuffer();
            const data = new Blob([buffer], { type: 'application/octet-stream' });
            filesaver.saveAs(data, `${this.filename}.xlsx`)
        }
    }
}
</script>